import { css } from "styled-components";
import token from "styled-token";
/** @mixin buttonStateMixin */

/**
 * @method
 */

export var buttonStateMixin = function buttonStateMixin(state) {
  if (state === void 0) {
    state = "";
  }

  return function (props) {
    var buttonType = props.buttonType,
        inverse = props.inverse,
        bare = props.bare,
        borderless = props.borderless;
    var variant = "" + buttonType + (inverse ? "Inverse" : "");
    return token({
      backgroundColor: "Button." + variant + ".backgroundColor" + state,
      borderColor: "Button." + variant + ".borderColor" + state,
      color: "Button." + variant + ".fontColor" + state
    }, function (_ref) {
      var backgroundColor = _ref.backgroundColor,
          borderColor = _ref.borderColor,
          color = _ref.color;
      var currentState = /*#__PURE__*/css(["background-color:", ";border-color:", ";color:", ";"], backgroundColor, borderless && state !== "Pressed" ? "transparent" : borderColor, color);

      if (bare) {
        currentState = css(["background-color:", ";border-color:", ";color:", ";"], state === "" ? "transparent" : backgroundColor, state !== "Pressed" ? "transparent" : borderColor, color);
      }

      return currentState;
    })(props);
  };
};